<template>
    <vue-modal></vue-modal>
    <!-- <vue-session-timer></vue-session-timer> -->
    <!-- <vue-header-page></vue-header-page> -->

    <div class="container">
        <div>
            <h1>Ошибка доступа</h1>
        </div>
    </div>
</template>

<script>
// import Logout from '@/VueWorking/Pages/Logout.vue';

export default {
    name: 'Error403',
    // components: { Logout },
    data() {
        return {
            // isAuthenticated: parseFloat(localStorage.authenticated),
            // isAuth: parseFloat(localStorage.authenticated) ? 'Да' : 'Нет',
            user: null,
        }
    },
    mounted(){
        // this.user = this.$store.state.user;
    },
    methods: {
        // testModal(type, label, message){
        //     window.$func.getAlert(type, label, message);
        // },
    }
}
</script>